/**
 * Matching information как на экзамене (T3, виды Reading как на engnovate, 30.10.2026): сетка «вопрос × буква» —
 * строки — утверждения, столбцы — буквы абзацев A–G, в клетке отметка. На телефоне под утверждением ряд букв.
 *
 * ⚠️ Значение ответа — ТЕКСТ ВАРИАНТА, как у выпадающего списка прежней карточки (`LegacyTaskCard`): у
 * `matching_info` варианты и есть буквы («A», «B»…), так что сервер, оценщик и сданные попытки не меняются.
 *
 * Сетка — только если все варианты — одиночные буквы и их от 2 до 10; иначе (старые задания с текстом в
 * вариантах) — прежняя карточка со списком (`matchGridLetters` → null).
 */
import type { StudentTask } from '../api/ieltsMock';

const LETTER = /^[A-Z]$/;

/** Буквы столбцов сетки или null — рисовать прежней карточкой. */
export function matchGridLetters(task: StudentTask): string[] | null {
  if (task.type !== 'matching_info' || !task.questions.length) return null;
  const opts = task.options ?? [];
  if (opts.length < 2 || opts.length > 10 || !opts.every((o) => LETTER.test(o.trim()))) return null;
  return opts.map((o) => o.trim());
}

/**
 * Строка «NB You may use any letter more than once.» отдельно от инструкции — на экзамене она стоит своей
 * строкой и её легко пропустить внутри абзаца. [инструкция без NB, строка NB или ''].
 */
export function splitNB(instruction: string): [string, string] {
  const m = /(^|\s)NB\b/.exec(instruction);
  if (!m) return [instruction, ''];
  const at = m.index + m[1].length;
  return [instruction.slice(0, at).trim(), instruction.slice(at).trim()];
}
